import React from "react";
import { CheckCircle2Icon, ListChecksIcon, LayersIcon, PhoneIcon, MessageSquareIcon, MailIcon, FileTextIcon, ZapIcon } from "lucide-react";
import { Card, CardHeader, ReadOnlyField, Badge } from "./primitives";
import { latestLoan, completionChecklist, formatCurrency } from "../data/contact";
function LoanSnapshotCard() {
  return <Card data-id="element-173" data-mp="3ypbkzn7o6x5">
      <CardHeader title="Loan Snapshot" icon={<LayersIcon className="h-4 w-4" data-id="element-175" data-mp="3v48no3t4q876" />} action={<Badge tone="green" data-id="element-176" data-mp="3qc7dcnfiurjs">Active</Badge>} data-id="element-174" data-mp="3v2nsqd2wkn8s" />
      <div className="space-y-4 px-5 py-5" data-id="element-177" data-mp="3qacv5gvmxdje">
        <div className="flex items-center justify-between" data-id="element-178" data-mp="3lcl1ahbfjhck">
          <span className="text-sm font-semibold text-slate-900" data-id="element-179" data-mp="3ld474znt2fa8">
            {latestLoan.name}
          </span>
          <Badge tone="blue" data-id="element-180" data-mp="3gbopzior0sx4">{latestLoan.status}</Badge>
        </div>
        <div className="grid grid-cols-2 gap-x-4 gap-y-4" data-id="element-181" data-mp="3cav22pbb3e48">
          <ReadOnlyField label="Purpose" value={latestLoan.loanPurpose} data-id="element-182" data-mp="37dbid9vua94w" />
          <ReadOnlyField label="Requested Amount" value={formatCurrency(latestLoan.loanAmount)} strong data-id="element-183" data-mp="37ffozzl4hm8v" />
          <ReadOnlyField label="Property" value={latestLoan.propertyAddress} data-id="element-184" data-mp="1qrfapjbzk0u3" />
          <ReadOnlyField label="City" value={latestLoan.propertyCity} data-id="element-185" data-mp="1czim3p9j092g" />
        </div>
      </div>
    </Card>;
}
function ChecklistCard() {
  const done = completionChecklist.filter(i => i.status === "complete").length;
  const total = completionChecklist.length;
  const pct = Math.round(done / total * 100);
  return <Card data-id="element-186" data-mp="29nygbynkz6lw">
      <CardHeader title="Next Best Fields to Complete" subtitle={`${done} of ${total} complete`} icon={<ListChecksIcon className="h-4 w-4" data-id="element-188" data-mp="1vrl00sus9b90" />} data-id="element-187" data-mp="29oq10efn3jxe" />
      <div className="px-5 pt-4" data-id="element-189" data-mp="20nie0sikq5im">
        <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-100" data-id="element-190" data-mp="20mqkdn8jehuz">
          <div className="h-full rounded-full bg-[#1a73e8] transition-all" style={{
          width: `${pct}%`
        }} data-id="element-191" data-mp="k8qkgc9oys7q" />
        </div>
      </div>
      <ul className="divide-y divide-slate-100 px-2 py-2" data-id="element-192" data-mp="2qz3m8yiiynd2">
        {completionChecklist.map(item => {
        const complete = item.status === "complete";
        return <li key={item.id} className="flex items-center gap-3 rounded-lg px-3 py-2.5 hover:bg-slate-50" data-id="element-193" data-mp="2h8isbodsq70h">
              {complete ? <CheckCircle2Icon className="h-4 w-4 shrink-0 text-emerald-500" data-id="element-194" data-mp="2d5co0ma8upwn" /> : <span className="flex h-4 w-4 shrink-0 items-center justify-center" data-id="element-195" data-mp="285q11l4m5van">
                  <span className="h-2.5 w-2.5 rounded-full bg-amber-400 ring-4 ring-amber-100" data-id="element-196" data-mp="23b2jk681215k" />
                </span>}
              <span className={`text-sm ${complete ? "text-slate-400 line-through decoration-slate-300" : "font-medium text-slate-700"}`} data-id="element-197" data-mp="1u8l01zjrbmm9">
                {item.label}
              </span>
            </li>;
      })}
      </ul>
    </Card>;
}
function QuickAction({
  icon,
  label,
  onClick,
  primary = false
}: {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
  primary?: boolean;
}) {
  return <button type="button" onClick={onClick} className={`flex items-center gap-2 rounded-lg border px-3 py-2.5 text-sm font-medium transition focus:outline-none focus:ring-2 focus:ring-blue-200 ${primary ? "border-[#1a73e8] bg-[#1a73e8] text-white hover:bg-blue-700" : "border-slate-200 bg-white text-slate-700 hover:border-blue-200 hover:bg-blue-50/50 hover:text-[#1a73e8]"}`} data-id="element-198" data-mp="1k5o2f2bhuqmv">
      <span className={primary ? "text-blue-100" : "text-slate-400"} data-id="element-199" data-mp="10iqaii46ta9q">{icon}</span>
      {label}
    </button>;
}
function QuickActionsCard({
  onCreateLoan
}: {
  onCreateLoan: () => void;
}) {
  return <Card data-id="element-200" data-mp="2gun8caolvgbw">
      <CardHeader title="Quick Actions" icon={<ZapIcon className="h-4 w-4" data-id="element-202" data-mp="2gtc3s8nc64jq" />} data-id="element-201" data-mp="2gudiqo7h3b6q" />
      <div className="grid grid-cols-2 gap-2 px-5 py-5" data-id="element-203" data-mp="2gwgi3yuimgo4">
        <QuickAction icon={<FileTextIcon className="h-4 w-4" data-id="element-205" data-mp="2ffkkhj1qpizj" />} label="Create New Loan" primary onClick={onCreateLoan} data-id="element-204" data-mp="2fe9hhlg4cf9h" />
        <QuickAction icon={<PhoneIcon className="h-4 w-4" data-id="element-207" data-mp="2of7jxzawsepy" />} label="Call" data-id="element-206" data-mp="2oeo54rgk26g5" />
        <QuickAction icon={<MessageSquareIcon className="h-4 w-4" data-id="element-209" data-mp="2kc1jx9ee3jrx" />} label="Text" data-id="element-208" data-mp="2kckqxv2i4nr6" />
        <QuickAction icon={<MailIcon className="h-4 w-4" data-id="element-211" data-mp="2ycc7a2ghqg8c" />} label="Email" data-id="element-210" data-mp="2kexh2viey4fb" />
        <QuickAction icon={<FileTextIcon className="h-4 w-4" data-id="element-213" data-mp="2ya99gw93jit2" />} label="Open Loan" data-id="element-212" data-mp="2yarcqcu6exah" />
      </div>
    </Card>;
}
export function Sidebar({
  onCreateLoan
}: {
  onCreateLoan: () => void;
}) {
  return <aside className="space-y-5 lg:sticky lg:top-[132px]" data-id="element-214" data-mp="381lzrjf8y0wz">
      <LoanSnapshotCard data-id="element-215" data-mp="332izsde4ikvv" />
      <ChecklistCard data-id="element-216" data-mp="334dhzjy0fyw9" />
      <QuickActionsCard onCreateLoan={onCreateLoan} data-id="element-217" data-mp="3355fj0b646p6" />
    </aside>;
}